var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.9488 15.5L10.0049 14.5625L16.6122 8L10.0049 1.4375L10.9488 0.5L18.5 8L10.9488 15.5Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M0.5 8.68182L17.7921 8.68182V7.31818L0.5 7.31818L0.5 8.68182Z","fill":"currentColor","key":1})]);
}

ArrowRightInline.defaultProps = {"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","preserveAspectRatio":"xMidYMid"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
